import React, { useMemo } from "react";

import { ReverseIcon } from "@plex/icons";

import { defaultLocale, ILocale, isDefaultLocale } from "infrastructure/localization";
import { useLocalizer } from "ui/hooks";

import styles from "../TermDictionary.module.scss";

export interface ILanguageDisplayValue {
  locale: ILocale;
  reverseLanguage: () => void;
  reversed?: boolean;
  bilingual?: boolean;
}

export const LanguageDisplayValue: React.FC<ILanguageDisplayValue> = ({ locale, reversed, bilingual, reverseLanguage }) => {
  const localize = useLocalizer();

  const defaultLocaleName = useMemo(() => localize({ value: defaultLocale.name }), [localize]);

  const translatedDefaultLocale = useMemo(() => ({ ...defaultLocale, name: defaultLocaleName }), [defaultLocaleName]);
  const locales = reversed ? [locale, translatedDefaultLocale] : [translatedDefaultLocale, locale];
  const industrySpecific = isDefaultLocale(locale.localeIdentifier);

  return bilingual ? (
    <>
      <span className={industrySpecific && reversed ? styles.industrySpecific : undefined}>{locales[0].name}</span>
      <i className={styles.reverseIcon} onClick={() => reverseLanguage()}>
        <ReverseIcon />
      </i>
      <span className={industrySpecific && !reversed ? styles.industrySpecific : undefined}>{locales[1].name}</span>
    </>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{locale.name}</>
  );
};
